import React from "react";

import styled from "@emotion/styled";

const PriceActionConditions = styled.div`
    font-size: 12px;
    text-align: center;
`;

const Hel2021PriceActionDisclaimer = () => {
    return (
        <PriceActionConditions>
            * Es gelten die aktuellen{" "}
            <a href="/heizoel/cleversparen" target="_blank">
                Teilnahmebedingungen
            </a>{" "}
            der Aktion.{" "}
        </PriceActionConditions>
    );
};

export default Hel2021PriceActionDisclaimer;
